import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "components/atoms/Button";
import Dropdown from "components/atoms/Dropdown";
import { FilterIcon } from "components/atoms/Icon";
import { Header } from "components/atoms/Typography";
import FiltersSidebar from "components/organisms/FiltersSidebar";
import { FilterLabelCards } from "components/organisms/FiltersSidebar/FilterLabelCards";
import posthog from "posthog-js";
import { useState } from "react";
import useReportsGroupByState from "recoilStore/useReportsGroupByState";
import NumberOfBuildings from "components/molecules/NumberOfBuildings/NumberOfBuildings";
import useCurrentFilterset from "queries/Reports/Baseline/useCurrentFilterset";
import ViewTab from "../../components/atoms/ViewTab";
import "./ReportsHeader.scss";
import ExportFiltersetButton from "./ExportFiltersetButton";

const groupByItems = [
    {
        id: "building",
        displayValue: "Group by Buildings",
    },
    {
        id: "property",
        displayValue: "Group by Properties",
    },
];

const filtersetSelectionItems = [
    {
        id: "reported",
        displayValue: "Audette plan",
    },
    {
        id: "published",
        displayValue: "My plan",
    },
];

function ReportsHeader() {
    const location = useLocation();
    const pathParts = location.pathname.split("/");
    const currentTab = pathParts[2] as ReportTab;
    const [isFilterSidebarOpen, setIsFilterSidebarOpen] = useState(false);
    const {
        reportedVsPublishedState,
        setStateReportedVsPublished,
        selectedFiltersetUid,
        isLoading: isLoadingFilterset,
    } = useCurrentFilterset();
    const { state: groupByMetric, setState: setGroupByMetric } = useReportsGroupByState();

    const handleFilterButtonClick = () => {
        posthog.capture("Open filters");
        setIsFilterSidebarOpen(true);
    };

    const closeFilterSidebar = () => {
        setIsFilterSidebarOpen(false);
    };
    return (
        <>
            <FiltersSidebar
                sidebarOpen={isFilterSidebarOpen}
                closeSidebar={closeFilterSidebar}
                currentActiveTab={currentTab}
            />
            <div className="reports-header">
                <div className="title">
                    <Header size="large">Reports</Header>
                    <Dropdown
                        items={filtersetSelectionItems}
                        style={{ marginRight: 7 }}
                        onSelectItem={(item) => {
                            setStateReportedVsPublished(item.id);
                            posthog.capture("Report filterset selection updated.");
                        }}
                        defaultItem={filtersetSelectionItems.find((item) => item.id === reportedVsPublishedState)}
                    />
                    {currentTab !== "plan" && (
                        <Dropdown
                            items={groupByItems}
                            onSelectItem={(item) => setGroupByMetric(item.id)}
                            defaultItem={groupByItems.find((item) => item.id === groupByMetric)}
                        />
                    )}
                    {!isLoadingFilterset && (
                        <ExportFiltersetButton
                            filtersetUid={selectedFiltersetUid}
                            reportedVsPublished={reportedVsPublishedState}
                        />
                    )}
                    <Button type="secondary" onClick={handleFilterButtonClick} icon={<FilterIcon />}>
                        Filters
                    </Button>
                </div>
                <NumberOfBuildings groupByMetric={groupByMetric} />
                <div className="filters">
                    <FilterLabelCards />
                </div>
                <ReportTabs />
            </div>
        </>
    );
}

function ReportTabs() {
    const navigate = useNavigate();
    const location = useLocation();
    const pathParts = location.pathname.split("/");
    const tabName = pathParts[2] as ReportTab;

    return (
        <div className="report-tabs">
            <ViewTab name="Baseline" onClick={() => navigate("baseline")} selected={tabName === "baseline"} />
            <ViewTab name="Outcomes" onClick={() => navigate("outcomes")} selected={tabName === "outcomes"} />
            <ViewTab name="Measures" onClick={() => navigate("plan")} selected={tabName === "plan"} />
        </div>
    );
}

export default ReportsHeader;
